module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/keepCoolExpired.fr_CA-9153361e59bcc76ae525d2724f6a85bb.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/keepCoolExpired.fr_CA.png
// module id = 2450
// module chunks = 2